import React from 'react';
import { useFairnessCalculator } from './useFairnessCalculator';
import { CalculatorFields } from './CalculatorFields';
import { CalculatorResult } from './CalculatorResult';
import './fairnessCalculator.css';

export const FairnessCalculator = ({ game, revealed }) => {
  const calculator = useFairnessCalculator(game, revealed);
  return <form className="fair-calc" data-testid="fairness-calculator" aria-label="Provably fair calculator" onSubmit={(event) => event.preventDefault()}>
    <CalculatorFields calculator={calculator} />
    <CalculatorResult calculator={calculator} />
  </form>;
};